import { Component, Input, EventEmitter, Output } from '@angular/core';
import { FormArray, AbstractControl } from '@angular/forms';
import { EventInfoWithConsentResponse, CompanySlotUpdateRequest, CompanySlotUpdate } from '@ent-regis/entregis-ts-angular';

@Component({
  selector: 'app-company-time-section',
  templateUrl: './company-time-section.component.html',
  styleUrls: ['./company-time-section.component.scss']
})
export class CompanyTimeSectionComponent {

  @Input() slots!: FormArray;
  @Input() eventType: EventInfoWithConsentResponse.EventTypeEnum;
  @Input() isCloseRegister: boolean = false;

  @Output() submitSlots = new EventEmitter<CompanySlotUpdateRequest>();
    
  eventTypeEnum = EventInfoWithConsentResponse.EventTypeEnum;
  public now = new Date();

  changeIsAvalable(form: AbstractControl) {
    form.setValue(!form.value);
  }

  toggleSelectAll(slot: any, checked: boolean) {
    const periods = slot.controls.slotPeriods.controls;
    periods.forEach(p => p.controls.isAvailable.setValue(checked));
  }

  isAllSelected(slot: any): boolean {
    const periods = slot.controls.slotPeriods.controls;
    return periods.every(p => p.controls.isAvailable.value);
  }

  get canSaveSlots(): boolean {
    return this.slots && this.slots.valid;
  }

  get isThailandFocus(): boolean {
    return this.eventType && this.eventType === this.eventTypeEnum.THAILANDFOCUS;
  }

  get timezone(): string {
    return this.isThailandFocus ? 'UTC +7' : null;
  }
  
  onSubmit(): void {
    const request: CompanySlotUpdateRequest = {
      companySlots: []
    };

    this.slots.controls.forEach(ctrl => {
      const v = ctrl.value;
      (v.slotPeriods || []).forEach(p => {
        request.companySlots.push({
          companySlotId: p.companySlotId,
          slotPeriodId: p.slotPeriodId,
          available: p.isAvailable ? CompanySlotUpdate.AvailableEnum.Y : CompanySlotUpdate.AvailableEnum.N
        } as CompanySlotUpdate);
      });
    });

    this.submitSlots.emit(request);
  }

}
